import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { MsvfileService } from '../../service/msvfile.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.css']
})
export class FileListComponent implements OnInit {

  dataTable: any[] = null;
  cols: any[];
  msgs: any[] = [];
  fromDate: Date = new Date();
  toDate: Date = new Date();
  userDetails: any;
  listcustomer: any[] = [];
  selectedCustomerId: any = null;

  constructor(private userService: UserService, private dataService: MsvfileService, private router: Router) { }

  ngOnInit() {
    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
    }, (err: HttpErrorResponse) => {
      this.userDetails = null;
      this.showMessage('error', '', 'תקלה בקבלת הרשאות');
    });

    this.dataService.getCustomerDDL().subscribe((result: any) => {
      this.listcustomer = result;
      this.listcustomer.unshift({ label: 'הכל', value: null });
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
    });

    this.cols = [
      { field: 'MsvFileName', header: 'שם קובץ' },
      { field: 'CustomerName', header: 'מעסיק' },
      { field: 'ExecutionDate', header: 'תאריך הגשה' },
      { field: 'StatusName', header: 'סטטוס' },
      { field: 'MaxSallaryMonth', header: 'חודש שכר (מקסימלי)' },
      { field: 'HafkadotNumber', header: 'מספר קופות' },
      //{ field: 'Result_Date', header: 'תאריך סטטוס' }
    ];
  }

  getReport(): void {
    if (this.fromDate && this.toDate && this.fromDate > this.toDate) {
      return this.showMessage('error', '', 'תאריך אינו חוקי. מתאריך לא יכול להיות קטן מעד תאריך');
    }
    this.selectedCustomerId = this.selectedCustomerId ? this.selectedCustomerId : '';
    this.dataService.getReport(this.selectedCustomerId, this.fromDate, this.toDate).subscribe((result: any) => {
      this.dataTable = result;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת דוח ');
    });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  completeData(fileId: number): void {
    if (fileId && fileId > 0) {
      this.router.navigate(['/MSV-complete-data', fileId]);
    }
    else {
      this.showMessage('error', '', 'שגיאה. לא ניתן להשלים נתונים');
    }
  }

  deleteMSVFile(fileId: number): void {
    if (fileId && fileId > 0) {
      this.dataService.statusUpdate(fileId).subscribe((result: string) => {
        if (result === 'Success') {
          this.showMessage('success', '', 'המחיקה בוצעה בהצלחה');
          this.getReport();
        }
      }, (error: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה במחיקה ');
      });
    }
    else {
      this.showMessage('error', '', 'שגיאה במחיקה');
    }
  }

  downloadMSVFile(fileName: string, fileId: number): void {
    if (fileName && fileId && fileId > 0) {
      try {
        this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
        let customerId: string = '';
        customerId = this.selectedCustomerId ? this.selectedCustomerId : '';
        this.dataService.getDownloadFile(fileName, fileId, customerId).subscribe((result: any) => {
          window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, fileName);
          }
          let url = window.URL.createObjectURL(result)
          let link = document.createElement('a');
          link.href = url;
          link.download = `${fileName}`;
          link.click();
          setTimeout(() => {
            this.showMessage('success', '', 'הקובץ נשמר בהצלחה');
          }, 1000);
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהורדת הקובץ');
        });
      } catch (error) {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      }
    } else {
      this.showMessage('error', '', 'תקלה בהכנת הורדת הקובץ');
    }
  }


  downloadXMLFile(fileName: string, fileId: number): void {
    if (fileName && fileId && fileId > 0) {
      try {
        this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
        let customerId: string = '';
        customerId = this.selectedCustomerId ? this.selectedCustomerId : '';
        this.dataService.getDownloadXmlFile(fileName, fileId, customerId).subscribe((result: any) => {
          window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, fileName);
          }
          let url = window.URL.createObjectURL(result)
          let link = document.createElement('a');
          link.href = url;
          link.download = `${fileName}`;
          link.click();
          setTimeout(() => {
            this.showMessage('success', '', 'הקובץ נשמר בהצלחה');
          }, 1000);
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהורדת הקובץ');
        });
      } catch (error) {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      }
    } else {
      this.showMessage('error', '', 'תקלה בהכנת הורדת הקובץ');
    }
  }
  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/MSVFile/file-list/file-list.component.ts